document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.collection-filter-container');
  const productsView = document.getElementById('collection-list-products');
  const collectionsView = document.getElementById('collection-list-collections');
  if (!container || !productsView || !collectionsView) return;

  function getPageFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const p = params.get('page');
    return p ? parseInt(p, 10) : 1;
  }

  function applyCollectionFilter(labelLower) {
    productsView.style.display = 'none';
    collectionsView.style.display = '';

    const list = collectionsView.querySelector('.collection-list');
    if (!list) return;

    const listItems = list.querySelectorAll('.collection-list__item');

    listItems.forEach(function (li) {
      const heading = li.querySelector('.card__heading');
      const itemText = (heading && heading.textContent) ? heading.textContent.trim().toLowerCase() : '';
      const matches = itemText.indexOf(labelLower) !== -1;
      li.style.display = matches ? '' : 'none';
      li.hidden = !matches;
    });

    const visibleItems = Array.from(listItems).filter(function (li) {
      const heading = li.querySelector('.card__heading');
      const itemText = (heading && heading.textContent) ? heading.textContent.trim().toLowerCase() : '';
      return itemText.indexOf(labelLower) !== -1;
    });

    visibleItems.forEach(function (li, index) {
      if (!li.classList.contains('scroll-trigger') || !li.classList.contains('animate--slide-in')) return;
      li.classList.add('scroll-trigger--offscreen');
      if (li.hasAttribute('data-cascade')) {
        li.style.setProperty('--animation-order', String(index));
      }
    });

    requestAnimationFrame(function () {
      visibleItems.forEach(function (li) {
        li.offsetHeight;
        li.classList.remove('scroll-trigger--offscreen');
      });
    });

    ensurePaginationPreservesFilter(labelLower);
  }

  function ensurePaginationPreservesFilter(filterLower) {
    if (!filterLower) return;
    var paginationLinks = collectionsView.querySelectorAll('.pagination a[href]');
    paginationLinks.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href.indexOf('filter=') !== -1) return;
      var sep = href.indexOf('?') !== -1 ? '&' : '?';
      a.setAttribute('href', href + sep + 'filter=' + encodeURIComponent(filterLower));
    });
  }

  function setActiveFilterButton(label) {
    container.querySelectorAll('.collection-filter-item').forEach(function (el) {
      el.classList.remove('active');
      if ((el.querySelector('p')?.textContent?.trim() || '').toLowerCase() === (label || '').toLowerCase()) {
        el.classList.add('active');
      }
    });
  }

  var urlParams = new URLSearchParams(window.location.search);
  var filterFromUrl = urlParams.get('filter');
  if (filterFromUrl && filterFromUrl.toLowerCase() !== 'everything') {
    setActiveFilterButton(filterFromUrl);
    applyCollectionFilter(filterFromUrl.toLowerCase());
  } else if (urlParams.has('filter')) {
    urlParams.delete('filter');
    var newSearch = urlParams.toString();
    var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    history.replaceState(null, '', newUrl);
  }

  container.addEventListener('click', function (e) {
    const item = e.target.closest('.collection-filter-item');
    if (!item) return;

    const label = item.querySelector('p')?.textContent?.trim();
    const labelLower = label ? label.toLowerCase() : '';

    container.querySelectorAll('.collection-filter-item').forEach(function (el) {
      el.classList.remove('active');
    });
    item.classList.add('active');

    if (labelLower === 'everything' || labelLower === '') {
      productsView.style.display = '';
      collectionsView.style.display = 'none';
      var params = new URLSearchParams(window.location.search);
      if (params.has('filter')) {
        params.delete('filter');
        var newSearch = params.toString();
        var newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
        history.replaceState(null, '', newUrl);
      }
      return;
    }

    if (getPageFromUrl() > 1) {
      window.location.href = window.location.pathname + '?page=1&filter=' + encodeURIComponent(labelLower);
      return;
    }

    applyCollectionFilter(labelLower);
  });
});
